import PageMeta from "@/components/common/PageMeta";
import seoData from "@/data/seo/seo-data.json";

interface PageSEOProps {
  section: keyof typeof seoData;
  keyName?: string; // only if section is an object of pages
}

export default function PageSEO({ section, keyName }: PageSEOProps) {
  let seo: any;

  if (keyName) {
	// Example: section="services", keyName="logo-design"
	seo = (seoData as any)[section]?.[keyName];
  } else {
	// Example: section="homepage"
	seo = (seoData as any)[section];
  }

  if (!seo) {
	console.warn(`⚠️ SEO data not found for section="${section}" keyName="${keyName}"`);
	return null;
  }

  return (
	<PageMeta
	  title={seo.title}
	  description={seo.description}
	  keywords={seo.keywords}
	  ogTitle={seo.ogTitle}
	  ogDescription={seo.ogDescription}
	  ogImage={seo.ogImage}
	  canonicalUrl={seo.canonicalUrl}
	  structuredData={seo.structuredData}
	  noindex={seo.noindex}
	  nofollow={seo.nofollow}
	/>
  );
}